export enum QuickLinks {
    SOLUTIONS = 'solutions',
    KNOW_HOW = 'know-how',
    INFORMATION = 'information',
    TOOLS = 'tools',
    NEWS = 'news',
    CAREER = 'career',
}
